// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactPageContainer_container__MOrAa","sidebar":"ContactPageContainer_sidebar__uGDJ3","mainSection":"ContactPageContainer_mainSection__LYP13"};